var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "pt-0 pb-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('Title', {
    attrs: {
      "title": "Данные исходной образовательной организации",
      "font-size": "15",
      "text-start": ""
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.speciality,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "return-object": ""
    },
    on: {
      "input": _vm.setApplication
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Специальность")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.application.specialityFrom,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "specialityFrom", $$v);
      },
      expression: "application.specialityFrom"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.courseNumber,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "return-object": ""
    },
    on: {
      "input": _vm.setApplication
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Номер курса")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.application.courseNumberFrom,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "courseNumberFrom", $$v);
      },
      expression: "application.courseNumberFrom"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.isActualSubmissionSession,
      "item-text": "semester.name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "return-object": ""
    },
    on: {
      "input": _vm.setApplication
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Семестр")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.application.submissionSession,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "submissionSession", $$v);
      },
      expression: "application.submissionSession"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showOrganizationNameFrom,
      expression: "!showOrganizationNameFrom"
    }],
    attrs: {
      "items": _vm.dictionaries.organization,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "return-object": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "hint": "Если вы не нашли название университета в выпадающем списке, введите название вручную, нажав на карандаш",
      "append-outer-icon": "mdi-pencil-outline"
    },
    on: {
      "click:append-outer": _vm.changeShowOrganizationNameFrom,
      "input": _vm.setApplication
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Наименование образовательной организации")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.application.organizationFrom,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "organizationFrom", $$v);
      },
      expression: "application.organizationFrom"
    }
  }), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showOrganizationNameFrom,
      expression: "showOrganizationNameFrom"
    }],
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": "",
      "append-outer-icon": "mdi-pencil-outline"
    },
    on: {
      "click:append-outer": _vm.changeShowOrganizationNameFrom,
      "input": _vm.setApplication
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Наименование образовательной организации")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.application.organizationNameFrom,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "organizationNameFrom", $$v);
      },
      expression: "application.organizationNameFrom"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.paidForm,
      "item-text": "name",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "placeholder": "Выберите из списка",
      "no-data-text": "Не найдено",
      "return-object": ""
    },
    on: {
      "input": _vm.setApplication
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Тип обучения")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.application.paidFormTo,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "paidFormTo", $$v);
      },
      expression: "application.paidFormTo"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }